module.exports = __webpack_public_path__ + "static/media/collection-bird-12-effect.0bf62fca.png";